<!--
 * @Author: hongzeyu hzy605933924@163.com
 * @Date: 2024-08-23 16:18:26
 * @LastEditors: hongzeyu hzy605933924@163.com
 * @LastEditTime: 2024-08-28 16:45:30
 * @FilePath: \exam-admin\src\views\login\rule.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="rule">
    <div class="rule-content">
      <div class="rule-title" style="text-align: center">
        职业技能等级认定考生守则
        <div class="rule-tip">
          <div>考试</div>
          <div>须知</div>
        </div>
      </div>
      <div class="rule-msg">{{ ruleIntroduce }}</div>

      <div class="rule-flex">
        <div class="rule-box" v-for="(item, key) in law" :key="key">
          <div clss="box-title">{{ item.title }}</div>
          <div class="box-rule" v-for="(rule, index) in item.rule" :key="index">
            {{ rule }}
          </div>
        </div>
      </div>
      <div class="rule-clock">
        距离开始考试时间还有：
        <span>{{ countdown }}</span>
        分钟
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
import { dateDiff } from "../../utils";
import { requestFullscreen, isFullscreen } from "@/utils/examGuard";
import { useAppStore } from "../../store";
import { examPaperGet, nodeCheck } from "@/api/index.js";
import { onUnmounted } from "vue";
const router = useRouter(); // 路由对象
const appStore = useAppStore();
const ruleIntroduce =
  "参加技能人才评价的人员，如在考试或考核中有舞弊行为，提出警告终止其舞弊行为；若经劝阻仍不悔改确认后取消其考试资格；冒名顶替参加考试者，故意扰乱考场秩序，当场取消考试资格，同时取消第二年申报技能人才评价资格；威胁考务人员人身安全者，性质极其严重者将移交公安司法机关处理。";
const law = [
  {
    title: "一、下列行为属于一般违纪",
    rule: [
      "（一）夹带资料（书籍、笔记、纸条等）进入考场者；",
      "（二）在考场内随便说话、交头接耳或左顾右盼者；",
      "（三）偷看他人试卷、抄袭他人答案者；",
      "（四）翻看资料（书籍、笔记、纸条等）者； ",
      "（五）帮助他人作弊者；",
    ],
  },
  {
    title: "二、下列行为属于严重违纪",
    rule: [
      "（一）醉酒参考者；",
      "（二）扰乱考场秩序，严重影响其他考生考试者；",
      "（三）出现恐吓、威胁监考老师及工作人员者；",
      "（四）违反考场规则，不听劝告造成严重后果者；",
      "（五）干扰、阻碍、打击、报复监考老师及工作人员者；",
      "（六）使用电子产品或其他方式传送答案。",
    ],
  },
];

const start = () => {
  router.push("/exam");
};
// 监听时间 到点进入考试页面
watch(
  () => appStore.getServerTime,
  (val) => {
    if (val >= new Date(appStore.getExamPaper?.startTime).getTime()) {
      start();
    }
  },
);
const countdown = computed(() => {
  return appStore.getServerTime && appStore.getExamPaper?.startTime
    ? dateDiff(appStore.getServerTime, appStore.getExamPaper.startTime)
    : "";
});
const onVisible = () => {
  nodeCheck();
};
onMounted(async () => {
  console.log("🟢 onMounted 执行");
  if (!isFullscreen()) {
    await requestFullscreen();
  }
  document.addEventListener("visibilitychange", onVisible);
  if (!appStore.getExamPaper) {
    const res = await examPaperGet(
      JSON.parse(localStorage.getItem("user_info")),
    );
    const data = res.data;
    appStore.SET_PAPER(data);
  }
});
onUnmounted(() => {
  document.removeEventListener("visibilitychange", onVisible);
});
</script>
<style scoped lang="less">
.rule {
  height: calc(100% - 200px);
  background-image: url("@/assets/images/rule/rule-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  overflow-y: auto;
  display: grid;
  justify-items: center;
  align-items: center;
  padding: 100px;
}
.rule-content {
  background-image: url("@/assets/images/rule/rule-title.png");
  background-size: 100%;
  background-repeat: no-repeat;
  padding: 70px 280px;
  background-color: #fff;
  border-radius: 20px;
  background-position: 0 0;
  box-shadow: 0 0 20px 2px #d9e2e899;
  /* margin: 100px auto 0; */
  height: calc(100% - 140px);
  .rule-title {
    color: #475056ff;
    font-size: 32px;
    margin-bottom: 48px;
    position: relative;
    .rule-tip {
      width: 60px;
      height: 70px;
      position: absolute;
      left: -280px;
      top: -30px;
      background-image: url("@/assets/images/exam/exam-tip.png");
      background-size: 100% 100%;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 16px;
    }
  }
  .rule-msg {
    color: #475056ff;
    font-size: 16px;
    line-height: 32px;
    margin-bottom: 60px;
  }
  .rule-flex {
    display: flex;
    justify-content: space-between;
    .rule-box {
      padding: 48px;
      background-color: #f9fafdff;
      border-radius: 10px;
      margin: 0 50px;
      font-size: 14px;
      line-height: 42px;
      .box-title {
        color: #475056ff;
      }
      .box-rule {
        color: #98a2a8ff;
      }
    }
  }
  .rule-clock {
    color: #475056ff;
    font-size: 38px;
    font-weight: bold;
    text-align: center;
    margin-top: 80px;
    span {
      color: #ff9e44ff;
    }
  }
}
</style>
